import { TStyles } from "utils/Styles";

const styles: TStyles = {
  textfield: {
    "& .MuiInputBase-root.MuiInputBase-multiline > .MuiInputBase-input": {
      p: 0,
    },
  },
};

export default styles;
